@if (colorLoader) {
  <div class="mh">
    <p-progressSpinner
      strokeWidth="5"
      fill="#EEEEEE"
      animationDuration=".5s"></p-progressSpinner>
  </div>
}

@if (!colorLoader) {
  <div>
    <div
      class="topedit"
      [ngClass]="{
        'special-investment-color':
          programTypeId === ProgramType.MSSP ||
          programTypeId === ProgramType.Operator
      }">
      {{ engagementTitle }}
      <span
        class="fa fa-pencil ico cpointer toprt"
        pTooltip="Edit"
        (click)="editEng()"
        (keydown.enter)="editEng()"
        tabindex="0"
        tooltipPosition="bottom"></span>
      <span
        class="fa fa-refresh ico cpointer toprt btnmr"
        pTooltip="Refresh"
        (click)="refreshAllTab()"
        (keydown.enter)="refreshAllTab()"
        tabindex="0"
        tooltipPosition="bottom"></span>
    </div>

    <div class="ui-g engdetails card">
      <div class="ui-g-9 ui-md-9 ui-g-12 engdetails2">
        @for (message of chngmsg; track message) {
          <p-message [life]="3000" [text]="message.detail"></p-message>
        }
        <form [formGroup]="formEditChangeEng" (ngSubmit)="onSubmitChangeEng()">
          <div class="ui-g">
            <div class="ui-md-3 ui-sm-6"><span>Engagement Key</span></div>
            <div class="ui-md-3 ui-sm-6">
              {{ formEngagementDetails.controls['engagementKey'].value }}
            </div>
            <div class="ui-md-3 ui-sm-6"><span>Status</span></div>
            <div class="ui-md-3 ui-sm-6">
              {{ formEngagementDetails.controls['enagementStatus'].value }}
            </div>
          </div>
          <div class="ui-g">
            <div class="ui-md-3 ui-sm-6"><span>Request ID</span></div>
            <div class="ui-md-3 ui-sm-6">
              {{ formEngagementDetails.controls['engagementRequestID'].value }}
            </div>
            <div class="ui-md-3 ui-sm-6"><span>Request Date</span></div>
            <div class="ui-md-3 ui-sm-6">
              {{ formEngagementDetails.controls['requestDate'].value }}
            </div>
          </div>
          <div class="ui-g">
            <div class="ui-md-3 ui-sm-6">
              <span>Engagement Name</span>
            </div>
            <div class="ui-md-3 ui-sm-6">
              {{ formEngagementDetails.controls['engagementName'].value }}
            </div>
            <div class="ui-md-3 ui-sm-6"><span>Engagement Type</span></div>
            <div class="ui-md-3 ui-sm-6">
              {{ formEngagementDetails.controls['engagementType'].value }}
            </div>
          </div>
          <div class="ui-g">
            <div class="ui-md-3 ui-sm-6"><span>PMO Partner Name</span></div>
            <div class="ui-md-3 ui-sm-6">
              {{ formEngagementDetails.controls['pMOPartnerName'].value }}
            </div>
            <div class="ui-md-3 ui-sm-6"><span>PMO Tenant Name</span></div>
            <div class="ui-md-3 ui-sm-6">
              {{
                formEngagementDetails.controls['enagementPMOTenantName'].value
              }}
            </div>
          </div>
          <div class="ui-g">
            <div class="ui-md-3 ui-sm-6"><span>Task Owner</span></div>
            <div class="ui-md-3 ui-sm-6">
              {{ formEngagementDetails.controls['enagementTaskOwner'].value }}
            </div>
            <div class="ui-md-3 ui-sm-6"><span>Next Steps</span></div>
            <div class="ui-md-3 ui-sm-6">
              {{ formEngagementDetails.controls['enagementNextSteps'].value }}
            </div>
          </div>
          <div class="ui-g">
            @if (engBtnNav && !changeEng) {
              <div class="ui-g-12 ui-md-12 ui-lg-12">
                <button
                  type="submit"
                  [disabled]="btnDisable"
                  pButton
                  class="flat btnmr">
                  Save
                </button>
                <button
                  type="button"
                  pButton
                  (click)="editChangeEngVal()"
                  class="ui-button-secondary flat">
                  Cancel
                </button>
              </div>
            }
          </div>
        </form>
      </div>
      <div class="ui-g-3 ui-md-3 ui-sm-12">
        <div class="livemsg">
          <p-scrollPanel [style]="{ width: '100%', height: '90px' }">
            <table>
              <tr *ngFor="let item of notes">
                <td>
                  <span class="msgname">{{ item.userAlias }}</span
                  ><span class="msgdate">
                    {{ item.createdDate | date: 'short' : 'UTC-8' }}(PST)</span
                  ><br /><span class="msgcontent">{{ item.notes }}</span>
                </td>
              </tr>
            </table>
          </p-scrollPanel>
          <form [formGroup]="formNotes" (ngSubmit)="onSubmitNotes()">
            <textarea
              pTextarea
              [rows]="2"
              pInputTextarea
              placeholder="Min 3 characters"
              minlength="3"
              maxlength="400"
              formControlName="notes"></textarea>
            <div style="position: relative; top: 4px">
              <button
                type="submit"
                tooltipPosition="bottom"
                pTooltip="Send"
                class="btnmsg">
                <i class="fa fa-paper-plane" aria-hidden="true"></i>
              </button>
              <button
                type="button"
                tooltipPosition="bottom"
                pTooltip="Refresh"
                class="btnmsg">
                <i
                  class="fa fa-refresh"
                  (click)="refreshNotes()"
                  aria-hidden="true"></i>
              </button>
              @if (release === 'Prod') {
                <a
                  target="_blank"
                  href="https://msit.powerbi.com/groups/bb67cbd8-99ea-4206-8501-7536c68201a7/reports/94a5287e-f98e-4494-8a7d-7c8bc1fbb0f2/ReportSection93188d28fe904944dd33?filter=Master_Engagement/EngagementKey eq '{{
                    engementId
                  }}'"
                  tooltipPosition="bottom"
                  pTooltip="History"
                  class="fa fa-history icohistory"
                  aria-hidden="true">
                </a>
              }
              @if (release !== 'Prod') {
                <a
                  target="_blank"
                  href="https://msit.powerbi.com/groups/b7cf08d2-8c22-4aa9-9a79-f4a8cd991f77/reports/1c164c70-828c-401d-b87a-2c075eab2888/ReportSection93188d28fe904944dd33?filter=Master_Engagement/EngagementKey eq '{{
                    engementId
                  }}'"
                  tooltipPosition="bottom"
                  pTooltip="History"
                  class="fa fa-history icohistory"
                  aria-hidden="true">
                </a>
              }
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
}

@if (!colorLoader) {
  <div class="scrollcontent boxtb">
    <p-tabs scrollable class="tabView" value="0">
      <p-tablist>
        <p-tab value="0">Partner</p-tab>
        @if (partnerPaymentDetails) {
          <p-tab value="1">Payment Profile</p-tab>
        }
        <p-tab value="2">Customer Details</p-tab>
        <p-tab value="3">Internal - To be updated by PMO</p-tab>
        <p-tab value="4">Usage Details</p-tab>
        <p-tab value="5">Engagement Details</p-tab>
        <p-tab value="6">{{ paymentInfoTitle }}</p-tab>
        @if (isSpecialInvestments) {
          <p-tab value="7">Activity Payment Milestone 2</p-tab>
        }
        @if (isCSIEngagement) {
          <p-tab value="8">Percentage based M2</p-tab>
        }
        @if (!isSpecialInvestments) {
          <p-tab value="9">POE Submission</p-tab>
        }
        @if (isSpecialInvestments) {
          <p-tab value="10">POE Submission</p-tab>
        }
      </p-tablist>
      <p-tabpanels>
        <p-tabpanel value="0">
          <div class="rtnav ui-g">
            <div class="ui-g-8 msgbox-8">
              @for (message of partnermsgs; track message) {
                <p-message [life]="3000" [text]="message.detail"></p-message>
              }
            </div>
            @if (!partbtnNav) {
              <div class="ui-g-3"></div>
            }
            @if (partbtnNav) {
              <div class="ui-g-3">
                <button
                  type="button"
                  pButton
                  (click)="editPartnerCancel()"
                  class="ui-button-secondary flat fl-rt">
                  Cancel
                </button>
                <button
                  type="submit"
                  pButton
                  (click)="onSubmitPartner()"
                  class="flat btnmr fl-rt">
                  Save
                </button>
              </div>
            }
            <div class="ui-g-1 edit-history-icon">
              <span
                class="fa fa-pencil ico cpointer fl-rt"
                pTooltip="Edit"
                (click)="editPartner()"
                (keyup.enter)="editPartner()"
                tabindex="0"
                tooltipPosition="bottom"></span>
              @if (release === 'Prod') {
                <a
                  target="_blank"
                  href="https://msit.powerbi.com/groups/bb67cbd8-99ea-4206-8501-7536c68201a7/reports/94a5287e-f98e-4494-8a7d-7c8bc1fbb0f2/ReportSectiond4034f79e79ab6d45be9?filter=Master_Engagement/EngagementKey eq '{{
                    engementId
                  }}'">
                  <span
                    class="fa fa-history ico cpointer fl-rt"
                    pTooltip="History"
                    tooltipPosition="bottom">
                  </span>
                </a>
              }
              @if (release !== 'Prod') {
                <a
                  target="_blank"
                  href="https://msit.powerbi.com/groups/b7cf08d2-8c22-4aa9-9a79-f4a8cd991f77/reports/1c164c70-828c-401d-b87a-2c075eab2888/ReportSectiond4034f79e79ab6d45be9?filter=Master_Engagement/EngagementKey eq '{{
                    engementId
                  }}'">
                  <span
                    class="fa fa-history ico cpointer fl-rt"
                    pTooltip="History"
                    tooltipPosition="bottom">
                  </span>
                </a>
              }
            </div>
          </div>
          <form [formGroup]="formPartner" class="ui-g-12">
            <div class="readonlytbox">
              <div class="ui-g">
                <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <div class="hdorg">System Generated</div>
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <div class="hdorg">PMO Confirmed</div>
                </div>
              </div>
              <div class="ui-g">
                <div class="ui-g-12 ui-md-4 ui-lg-4">PartnerID</div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <input
                    type="text"
                    pInputText
                    readonly
                    formControlName="mPNID" />
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <input
                    type="text"
                    pInputText
                    [readonly]="isReadonlypart"
                    formControlName="pmomPNID" />
                </div>
              </div>
              <div class="ui-g">
                <div class="ui-g-12 ui-md-4 ui-lg-4">Partner Name</div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <input
                    type="text"
                    pInputText
                    readonly
                    formControlName="partnerName" />
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <input
                    type="text"
                    pInputText
                    [readonly]="isReadonlypart"
                    formControlName="pmopartnerName" />
                </div>
              </div>
              <div class="ui-g">
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  Partner Input - Requestor Contact
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <input
                    type="text"
                    pInputText
                    [readonly]="isReadonlypart"
                    formControlName="partnerInputRequestorContact" />
                </div>
              </div>
              <div class="ui-g">
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  Partner Input - Partner Info
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <input
                    type="text"
                    pInputText
                    [readonly]="isReadonlypart"
                    formControlName="partnerInputRequestorEmail" />
                </div>
              </div>
              @if (
                !(
                  programTypeId === ProgramType.MSSP ||
                  programTypeId === ProgramType.Operator
                )
              ) {
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    SSPA Status Compliant
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      [readonly]="isReadonlypart"
                      formControlName="sSPAStatusCompliant" />
                  </div>
                </div>
              }
              <div class="ui-g">
                <div class="ui-g-12 ui-md-4 ui-lg-4">Partner Type</div>
                <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <p-select
                    appendTo="body"
                    [options]="partnertypes"
                    [readonly]="isReadonlypart"
                    formControlName="partnerType"
                    placeholder="--SELECT--"
                    optionLabel="partnerType"
                    [class.readonlydd]="isReadonlypart === true"></p-select>
                </div>
              </div>
              <div class="ui-g">
                <div class="ui-g-12 ui-md-4 ui-lg-4">Customer Location</div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <input
                    type="text"
                    pInputText
                    readonly
                    value="United States"
                    formControlName="countryName" />
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
              </div>
              <div class="ui-g">
                <div class="ui-g-12 ui-md-12 ui-lg-12">
                  <div class="hdbl">Internal Reference</div>
                </div>
              </div>
              <div class="ui-g">
                <div class="ui-g-12 ui-md-4 ui-lg-4">Partner Name</div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <input
                    type="text"
                    pInputText
                    readonly
                    formControlName="InternalRefPartnerName" />
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
              </div>
              <div class="ui-g">
                <div class="ui-g-12 ui-md-4 ui-lg-4">Partner One ID</div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <input
                    type="text"
                    pInputText
                    readonly
                    formControlName="partnerOneID" />
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
              </div>
              <div class="ui-g">
                <div class="ui-g-12 ui-md-4 ui-lg-4">Partner Location</div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <input
                    type="text"
                    pInputText
                    readonly
                    formControlName="partnerLocation" />
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
              </div>
              <div class="ui-g">
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  Partner Earned Location
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <input
                    type="text"
                    pInputText
                    readonly
                    formControlName="partnerEarnedLocation" />
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
              </div>
              <div class="ui-g">
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  Partner Area Location (A14)
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <input
                    type="text"
                    pInputText
                    readonly
                    formControlName="partnerAreaLocationA14" />
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
              </div>
              <div class="ui-g">
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  Additional Contact Info
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <input
                    type="text"
                    pInputText
                    [readonly]="isReadonlypart"
                    formControlName="additionalContactEmails" />
                </div>
              </div>
            </div>
          </form>
        </p-tabpanel>
        <p-tabpanel value="1">
          @if (
            partnerPaymentDetails && partnerPaymentDetails.paymentProfileInfo
          ) {
            <form>
              <div class="ui-g">
                <div class="ui-g-12 ui-md-8 ui-lg-8">
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-6 ui-lg-6">
                      Partner Payee Name
                    </div>
                    <div class="ui-g-12 ui-md-6 ui-lg-6">
                      {{ partnerPaymentDetails.paymentProfileInfo.payeeName }}
                    </div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-6 ui-lg-6">
                      Payee Contact Name
                    </div>
                    <div class="ui-g-12 ui-md-6 ui-lg-6">
                      {{ payeeContactName }}
                    </div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-6 ui-lg-6">
                      Payee Contact Email
                    </div>
                    <div class="ui-g-12 ui-md-6 ui-lg-6">
                      {{
                        partnerPaymentDetails.paymentProfileInfo
                          .payeeContactEmail
                      }}
                    </div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-6 ui-lg-6">Supplier ID</div>
                    <div class="ui-g-12 ui-md-6 ui-lg-6">
                      {{ partnerPaymentDetails.supplierId }}
                    </div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-6 ui-lg-6">Vendor ID</div>
                    <div class="ui-g-12 ui-md-6 ui-lg-6">
                      {{
                        partnerPaymentDetails.vendorId === 0
                          ? 'N/A'
                          : partnerPaymentDetails.vendorId
                      }}
                    </div>
                  </div>
                  <div class="ui-g">
                    <div
                      class="ui-xl-6 ui-g-12 ui-md-6 ui-lg-6 align-activity pl-0 pr-0 mb-1">
                      <span
                        class="activity-font font-bold payment-title align pr-2"
                        aria-label="Payment profile"
                        ><i class="mdl2-payment-profile mr-2"></i>Payment
                        profile</span
                      >
                    </div>
                    <div class="ui-xl-6 ui-g-12 ui-md-6 ui-lg-6 activity-font">
                      <div
                        class="font-bold"
                        aria-label="payment profile status"
                        [ngClass]="
                          getStyleForPaymentProfileStatus(
                            partnerPaymentDetails.paymentProfileStatusDescription ||
                              ''
                          )
                        ">
                        {{
                          getPaymentProfileStatus(
                            partnerPaymentDetails.paymentProfileStatusDescription ||
                              ''
                          )
                        }}
                      </div>
                    </div>
                  </div>
                  <div class="ui-g">
                    <div
                      class="ui-xl-6 ui-g-12 ui-md-6 ui-lg-6 align-activity pl-0 pr-0 mb-1">
                      <span
                        class="activity-font font-bold payment-title align pr-2"
                        ><i class="mdl2-contract-status mr-2"></i>Program
                        agreement</span
                      >
                    </div>
                    <div class="ui-xl-6 ui-g-12 ui-md-6 ui-lg-6 activity-font">
                      @if (partnerPaymentDetails.contractStatus) {
                        <div class="font-bold green" aria-label="Green">
                          Green
                        </div>
                      }
                      @if (!partnerPaymentDetails.contractStatus) {
                        <div class="font-bold red" aria-label="Red">Red</div>
                      }
                    </div>
                  </div>
                  @if (
                    !(
                      programTypeId === ProgramType.MSSP ||
                      programTypeId === ProgramType.Operator
                    )
                  ) {
                    <div class="ui-g">
                      <div
                        class="ui-xl-6 ui-g-12 ui-md-6 ui-lg-6 align-activity pl-0 pr-0 mb-1">
                        <span
                          class="activity-font font-bold payment-title align pr-2"
                          aria-label="SSPA & anti-corruption">
                          <i class="mdl2-sspa mr-2"></i>SSPA & anti-corruption
                        </span>
                      </div>
                      <div
                        class="ui-xl-6 ui-g-12 ui-md-6 ui-lg-6 activity-font">
                        @if (partnerPaymentDetails.sspaAndAntiCorruption) {
                          <div class="font-bold green" aria-label="Green">
                            Green
                          </div>
                        }
                        @if (!partnerPaymentDetails.sspaAndAntiCorruption) {
                          <div class="font-bold red" aria-label="Red">Red</div>
                        }
                      </div>
                    </div>
                  }
                </div>
              </div>
            </form>
          }
        </p-tabpanel>
        <p-tabpanel value="2">
          <div class="rtnav ui-g">
            <div class="ui-g-8 msgbox-8">
              @for (message of custmsgs; track message) {
                <p-message [life]="3000" [text]="message.detail"></p-message>
              }
            </div>
            @if (!custbtnNav) {
              <div class="ui-g-3"></div>
            }
            @if (custbtnNav) {
              <div class="ui-g-3">
                <button
                  type="button"
                  pButton
                  (click)="editCustomerCancel()"
                  class="ui-button-secondary flat fl-rt">
                  Cancel
                </button>
                <button
                  type="submit"
                  pButton
                  (click)="onSubmitCustomer()"
                  class="flat btnmr fl-rt">
                  Save
                </button>
              </div>
            }
            <div class="ui-g-1 edit-history-icon">
              <span
                class="fa fa-pencil ico cpointer fl-rt"
                pTooltip="Edit"
                (click)="editCustomer()"
                (keyup.enter)="editCustomer()"
                tabindex="0"
                tooltipPosition="bottom"></span>
              @if (release === 'Prod') {
                <a
                  target="_blank"
                  href="https://msit.powerbi.com/groups/bb67cbd8-99ea-4206-8501-7536c68201a7/reports/94a5287e-f98e-4494-8a7d-7c8bc1fbb0f2/ReportSection68de820ffb1c18cdb075?filter=Master_Engagement/EngagementKey eq '{{
                    engementId
                  }}'">
                  <span
                    class="fa fa-history ico cpointer fl-rt"
                    pTooltip="History"
                    tooltipPosition="bottom"></span>
                </a>
              }
              @if (release !== 'Prod') {
                <a
                  target="_blank"
                  href="https://msit.powerbi.com/groups/b7cf08d2-8c22-4aa9-9a79-f4a8cd991f77/reports/1c164c70-828c-401d-b87a-2c075eab2888/ReportSection68de820ffb1c18cdb075?filter=Master_Engagement/EngagementKey eq '{{
                    engementId
                  }}'">
                  <span
                    class="fa fa-history ico cpointer fl-rt"
                    pTooltip="History"
                    tooltipPosition="bottom"></span>
                </a>
              }
            </div>
          </div>
          <form [formGroup]="formCustomer">
            <div class="readonlytbox">
              <div class="ui-g">
                <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <div class="hdorg">System Generated</div>
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <div class="hdorg">PMO Confirmed</div>
                </div>
              </div>
              <div class="ui-g">
                <div class="ui-g-12 ui-md-4 ui-lg-4">TPID</div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <input
                    type="text"
                    pInputText
                    (keypress)="numberOnly($event)"
                    readonly
                    formControlName="tPID" />
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <input
                    type="text"
                    pInputText
                    (keypress)="numberOnly($event)"
                    [readonly]="isReadonlycust"
                    formControlName="pmotPID" />
                </div>
              </div>
              <div class="ui-g">
                <div class="ui-g-12 ui-md-4 ui-lg-4">TPName</div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <input
                    type="text"
                    pInputText
                    readonly
                    formControlName="tPName" />
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <input
                    type="text"
                    pInputText
                    [readonly]="isReadonlycust"
                    formControlName="pmotPName" />
                </div>
              </div>
              <div class="ui-g">
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  Customer TPID List based on Tenant ID
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <input
                    type="text"
                    pInputText
                    readonly
                    formControlName="customerTPIDListbasedonTenantID" />
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
              </div>
              <div class="ui-g">
                <div class="ui-g-12 ui-md-4 ui-lg-4">Segment Group</div>
                <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <input
                    type="text"
                    pInputText
                    [readonly]="isReadonlycust"
                    formControlName="segmentGroup" />
                </div>
              </div>
              <div class="ui-g">
                <div class="ui-g-12 ui-md-4 ui-lg-4">Customer Area</div>
                <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <input
                    type="text"
                    pInputText
                    [readonly]="isReadonlycust"
                    formControlName="pmocustomerArea" />
                </div>
              </div>
              <div class="ui-g">
                <div class="ui-g-12 ui-md-4 ui-lg-4">Customer Country</div>
                <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <input
                    type="text"
                    pInputText
                    [readonly]="isReadonlycust"
                    formControlName="pmocustomerCountry" />
                </div>
              </div>
              <div class="ui-g">
                <div class="ui-g-12 ui-md-4 ui-lg-4">Usage Area</div>
                <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <input
                    type="text"
                    pInputText
                    [readonly]="isReadonlycust"
                    formControlName="pmousageArea" />
                </div>
              </div>
              <div class="ui-g">
                <div class="ui-g-12 ui-md-4 ui-lg-4">Usage Country</div>
                <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <input
                    type="text"
                    pInputText
                    [readonly]="isReadonlycust"
                    formControlName="pmousageCountry" />
                </div>
              </div>
              <div class="ui-g">
                <div class="ui-g-12 ui-md-4 ui-lg-4">Tenant ID</div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <input
                    type="text"
                    pInputText
                    readonly
                    formControlName="tenantID" />
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <input
                    type="text"
                    pInputText
                    [readonly]="isReadonlycust"
                    formControlName="pmotenantID" />
                </div>
              </div>
              <div class="ui-g">
                <div class="ui-g-12 ui-md-4 ui-lg-4">Tenant Name</div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <input
                    type="text"
                    pInputText
                    readonly
                    formControlName="tanantName" />
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <input
                    type="text"
                    pInputText
                    [readonly]="isReadonlycust"
                    formControlName="pmotanantName" />
                </div>
              </div>
              <div class="ui-g">
                <div class="ui-g-12 ui-md-4 ui-lg-4">Domain Name</div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <input
                    type="text"
                    pInputText
                    readonly
                    formControlName="domainName" />
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <input
                    type="text"
                    pInputText
                    [readonly]="isReadonlycust"
                    formControlName="pmodomainName" />
                </div>
              </div>
              <div class="ui-g">
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  Tenant List based on TPID
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <input
                    type="text"
                    pInputText
                    readonly
                    formControlName="tenantListbasedonTPID" />
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
              </div>
            </div>
          </form>
        </p-tabpanel>
        <p-tabpanel value="3"
          ><div class="rtnav ui-g">
            <div class="ui-g-6 msgbox-6">
              @for (message of intpmomsgs; track message) {
                <p-message [life]="3000" [text]="message.detail"></p-message>
              }
            </div>
            @if (!intPMObtnNav) {
              <div class="ui-g-5"></div>
            }
            @if (intPMObtnNav) {
              <div class="ui-g-5">
                <button
                  type="button"
                  pButton
                  (click)="CancelPmoDetails()"
                  class="ui-button-secondary flat fl-rt">
                  Cancel
                </button>
                <button
                  type="submit"
                  pButton
                  (click)="onSubmitInternalPMO()"
                  class="flat btnmr fl-rt">
                  Save
                </button>
              </div>
            }
            <div class="ui-g-1 edit-history-icon">
              <span
                class="fa fa-pencil ico cpointer fl-rt"
                pTooltip="Edit"
                (click)="editInternalPMO()"
                (keyup.enter)="editInternalPMO()"
                tabindex="0"
                tooltipPosition="bottom"></span>
              @if (release === 'Prod') {
                <a
                  target="_blank"
                  href="https://msit.powerbi.com/groups/bb67cbd8-99ea-4206-8501-7536c68201a7/reports/94a5287e-f98e-4494-8a7d-7c8bc1fbb0f2/ReportSection07ba9333714d04de3865?filter=Master_Engagement/EngagementKey eq '{{
                    engementId
                  }}'">
                  <span
                    class="fa fa-history ico cpointer fl-rt"
                    pTooltip="History"
                    tooltipPosition="bottom">
                  </span>
                </a>
              }
              @if (release !== 'Prod') {
                <a
                  target="_blank"
                  href="https://msit.powerbi.com/groups/b7cf08d2-8c22-4aa9-9a79-f4a8cd991f77/reports/1c164c70-828c-401d-b87a-2c075eab2888/ReportSection07ba9333714d04de3865?filter=Master_Engagement/EngagementKey eq '{{
                    engementId
                  }}'">
                  <span
                    class="fa fa-history ico cpointer fl-rt"
                    pTooltip="History"
                    tooltipPosition="bottom">
                  </span>
                </a>
              }
            </div>
          </div>
          <form [formGroup]="formInternalPMO">
            <div class="readonlytbox">
              <div class="ui-g">
                <div class="ui-g-12 ui-md-5 ui-lg-5">
                  Fully executed and paid from the FY19 TWA Program (Y/N)
                </div>
                <div class="ui-g-12 ui-md-2 ui-lg-2">
                  <p-radioButton
                    name="fullyexecutedandpaidfromtheFY19TWAProgramYN"
                    value="true"
                    formControlName="fullyexecutedandpaidfromtheFY19TWAProgramYN"
                    inputId="opt1"></p-radioButton>
                  <label for="opt1" class="ml-2">Yes</label>
                  <p-radioButton
                    class="ml-4"
                    name="fullyexecutedandpaidfromtheFY19TWAProgramYN"
                    value="false"
                    formControlName="fullyexecutedandpaidfromtheFY19TWAProgramYN"
                    inputId="opt1"></p-radioButton>
                  <label for="opt1" class="ml-2">No</label>
                </div>
                <div class="ui-g-12 ui-md-2 ui-lg-2">RequestID(s)</div>
                <div class="ui-g-12 ui-md-3 ui-lg-3">
                  <input
                    type="text"
                    pInputText
                    [readonly]="isReadonlyIntPMO"
                    formControlName="fullyexecutedandpaidfromtheFY19TWAProgramYNrequestIds" />
                </div>
              </div>
              <div class="ui-g">
                <div class="ui-g-12 ui-md-5 ui-lg-5">
                  Fully executed and paid from the FY19 MDA Program (Y/N)
                </div>
                <div class="ui-g-12 ui-md-2 ui-lg-2">
                  <p-radioButton
                    name="fullyexecutedandpaidfromtheFY19MDAProgramYN"
                    value="true"
                    formControlName="fullyexecutedandpaidfromtheFY19MDAProgramYN"
                    inputId="opt2"></p-radioButton
                  ><label for="opt2" class="ml-2">Yes</label>
                  <p-radioButton
                    class="ml-4"
                    name="fullyexecutedandpaidfromtheFY19MDAProgramYN"
                    value="false"
                    formControlName="fullyexecutedandpaidfromtheFY19MDAProgramYN"
                    inputId="opt2"></p-radioButton
                  ><label for="opt2" class="ml-2">No</label>
                </div>
                <div class="ui-g-12 ui-md-2 ui-lg-2">RequestID(s)</div>
                <div class="ui-g-12 ui-md-3 ui-lg-3">
                  <input
                    type="text"
                    pInputText
                    [readonly]="isReadonlyIntPMO"
                    formControlName="fullyexecutedandpaidfromtheFY19MDAProgramYNrequestIds" />
                </div>
              </div>
              <div class="ui-g">
                <div class="ui-g-12 ui-md-5 ui-lg-5">
                  Partner Requested same Tenant ID (Y/N)
                </div>
                <div class="ui-g-12 ui-md-2 ui-lg-2">
                  <p-radioButton
                    name="partnerRequestedsameTenantIDYN"
                    value="true"
                    formControlName="partnerRequestedsameTenantIDYN"
                    inputId="opt3"></p-radioButton
                  ><label for="opt3" class="ml-2">Yes</label>
                  <p-radioButton
                    name="partnerRequestedsameTenantIDYN"
                    class="ml-4"
                    value="false"
                    formControlName="partnerRequestedsameTenantIDYN"
                    inputId="opt3"></p-radioButton
                  ><label for="opt3" class="ml-2">No</label>
                </div>
                <div class="ui-g-12 ui-md-2 ui-lg-2">RequestID(s)</div>
                <div class="ui-g-12 ui-md-3 ui-lg-3">
                  <input
                    type="text"
                    pInputText
                    [readonly]="isReadonlyIntPMO"
                    formControlName="partnerRequestedsameTenantIDYNrequestIds" />
                </div>
              </div>
              <div class="ui-g">
                <div class="ui-g-12 ui-md-5 ui-lg-5">
                  Another Partner Requested Same Tenant ID (Y/N)
                </div>
                <div class="ui-g-12 ui-md-2 ui-lg-2">
                  <p-radioButton
                    name="anotherPartnerRequestedSameTenantID"
                    value="true"
                    formControlName="anotherPartnerRequestedSameTenantID"
                    inputId="opt4"></p-radioButton
                  ><label for="opt4" class="ml-2">Yes</label>
                  <p-radioButton
                    name="anotherPartnerRequestedSameTenantID"
                    class="ml-4"
                    value="false"
                    formControlName="anotherPartnerRequestedSameTenantID"
                    inputId="opt4"></p-radioButton
                  ><label for="opt4" class="ml-2">No</label>
                </div>
                <div class="ui-g-12 ui-md-2 ui-lg-2">MPNID(s)</div>
                <div class="ui-g-12 ui-md-3 ui-lg-3">
                  <input
                    type="text"
                    pInputText
                    [readonly]="isReadonlyIntPMO"
                    formControlName="anotherPartnerRequestedSameTenantIDMpnids" />
                </div>
              </div>
              <div class="ui-g">
                <div class="ui-g-12 ui-md-5 ui-lg-5">SMC SW Partner</div>
                <div class="ui-g-12 ui-md-2 ui-lg-2">
                  <p-radioButton
                    name="C3SWPartner"
                    value="true"
                    formControlName="C3SWPartner"
                    inputId="opt5"></p-radioButton
                  ><label for="opt5" class="ml-2">Yes</label>
                  <p-radioButton
                    name="C3SWPartner"
                    class="ml-4"
                    value="false"
                    formControlName="C3SWPartner"
                    inputId="opt5"></p-radioButton
                  ><label for="opt5" class="ml-2">No</label>
                </div>
                <div class="ui-g-12 ui-md-2 ui-lg-2"></div>
                <div class="ui-g-12 ui-md-3 ui-lg-3"></div>
              </div>
              <div class="ui-g">
                <div class="ui-g-12 ui-md-5 ui-lg-5">SMC TWA Partner</div>
                <div class="ui-g-12 ui-md-2 ui-lg-2">
                  <p-radioButton
                    name="C3TWAPartner"
                    value="true"
                    formControlName="C3TWAPartner"
                    inputId="opt6"></p-radioButton
                  ><label for="opt6" class="ml-2">Yes</label>
                  <p-radioButton
                    name="C3TWAPartner"
                    class="ml-4"
                    value="false"
                    formControlName="C3TWAPartner"
                    inputId="opt6"></p-radioButton
                  ><label for="opt6" class="ml-2">No</label>
                </div>
                <div class="ui-g-12 ui-md-2 ui-lg-2"></div>
                <div class="ui-g-12 ui-md-3 ui-lg-3"></div>
              </div>
            </div></form
        ></p-tabpanel>
        <p-tabpanel value="4"
          ><div class="rtnav ui-g">
            <div class="ui-g-8 msgbox-8">
              @for (message of msgsUsageDetails; track message) {
                <p-message [life]="3000" [text]="message.detail"></p-message>
              }
            </div>
            @if (isReadonlyUsage) {
              <div class="ui-g-3"></div>
            }
            @if (!isReadonlyUsage) {
              <div class="ui-g-3">
                <button
                  type="button"
                  pButton
                  (click)="cancelEditUsage()"
                  class="ui-button-secondary flat fl-rt">
                  Cancel
                </button>
                <button
                  type="submit"
                  pButton
                  (click)="onSubmitUsageDetails()"
                  class="flat btnmr fl-rt">
                  Save
                </button>
              </div>
            }
            <div class="ui-g-1 edit-history-icon">
              <span
                class="fa fa-pencil ico cpointer fl-rt"
                pTooltip="Edit"
                (click)="editUsage()"
                (keyup.enter)="editUsage()"
                tabindex="0"
                tooltipPosition="bottom"></span>
              @if (release === 'Prod') {
                <a
                  target="_blank"
                  href="https://msit.powerbi.com/groups/bb67cbd8-99ea-4206-8501-7536c68201a7/reports/94a5287e-f98e-4494-8a7d-7c8bc1fbb0f2/ReportSection3e8f0b64f265955e7f95?filter=Master_Engagement/EngagementKey eq '{{
                    engementId
                  }}'">
                  <span
                    class="fa fa-history ico cpointer fl-rt"
                    pTooltip="History"
                    tooltipPosition="bottom">
                  </span>
                </a>
              }
              @if (release !== 'Prod') {
                <a
                  target="_blank"
                  href="https://msit.powerbi.com/groups/b7cf08d2-8c22-4aa9-9a79-f4a8cd991f77/reports/1c164c70-828c-401d-b87a-2c075eab2888/ReportSection3e8f0b64f265955e7f95?filter=Master_Engagement/EngagementKey eq '{{
                    engementId
                  }}'">
                  <span
                    class="fa fa-history ico cpointer fl-rt"
                    pTooltip="History"
                    tooltipPosition="bottom">
                  </span>
                </a>
              }
            </div>
          </div>
          <form [formGroup]="formUsageDetails" class="overflow-setting">
            <div class="readonlytbox">
              <div class="ui-g">
                <div class="ui-g-12 ui-md-4 ui-lg-4">Usage Snapshot Date</div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <p-datepicker
                    appendTo="body"
                    formControlName="usageSnapshotDate"
                    dateFormat="mm/dd/yy"
                    placeholder="mm/dd/yy"
                    [readonlyInput]="true"
                    [showOnFocus]="false"
                    [iconDisplay]="'input'"
                    [disabled]="isReadonlyUsage"
                    [showIcon]="isReadonlyUsage === false"
                    [class.readonlycaltb]="isReadonlyUsage === true"
                    [defaultDate]="maxYearDate">
                  </p-datepicker>
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
              </div>
              <div class="ui-g">
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  Adjusted PC Installed Base (via DUIT)
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <input
                    type="text"
                    pInputText
                    [readonly]="isReadonlyUsage"
                    (keypress)="numberOnly($event)"
                    (keyup)="windows10MAD()"
                    formControlName="adjustedPCInstalledBase" />
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
              </div>
              <div class="ui-g">
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  Windows 10 MAD (Windows 10 Offer only)
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <input
                    type="text"
                    pInputText
                    [readonly]="isReadonlyUsage"
                    (keypress)="numberOnly($event)"
                    (keyup)="windows10MAD()"
                    formControlName="windows10MAD" />
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
              </div>
              <div class="ui-g">
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  Windows 10 MAD % (Windows 10 Offer only) must be less than 40%
                  deployed
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <div class="ui-inputgroup">
                    <input
                      type="text"
                      pInputText
                      readonly
                      (keypress)="numberOnly($event)"
                      formControlName="windows10MADPer"
                      class="text-right" />
                    <span class="ui-inputgroup-addon">%</span>
                  </div>
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
              </div>
              <div class="ui-g">
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  ProPlus Paid Entitlements
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <input
                    type="text"
                    pInputText
                    [readonly]="isReadonlyUsage"
                    (keypress)="numberOnly($event)"
                    formControlName="proPlusPaidEntitlements"
                    (keyup)="proPlusactiveusers()" />
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
              </div>
              <div class="ui-g">
                <div class="ui-g-12 ui-md-4 ui-lg-4">ProPlus Active Users</div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <input
                    type="text"
                    pInputText
                    [readonly]="isReadonlyUsage"
                    (keypress)="numberOnly($event)"
                    formControlName="proPlusActiveUsers"
                    (keyup)="proPlusactiveusers()" />
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
              </div>
              <div class="ui-g">
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  ProPlus active users % (must be < 40%)
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <div class="ui-inputgroup">
                    <input
                      type="text"
                      pInputText
                      readonly
                      (keypress)="numberOnly($event)"
                      formControlName="proPlusActiveUsers40Per"
                      class="text-right" />
                    <span class="ui-inputgroup-addon">%</span>
                  </div>
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
              </div>
              <div class="ui-g">
                <div class="ui-g-12 ui-md-4 ui-lg-4">EXO Paid Entitlements</div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <input
                    type="text"
                    pInputText
                    [readonly]="isReadonlyUsage"
                    (keypress)="numberOnly($event)"
                    (keyup)="eXOactiveusers()"
                    formControlName="eXOPaidEntitlements" />
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
              </div>
              <div class="ui-g">
                <div class="ui-g-12 ui-md-4 ui-lg-4">EXO active users</div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <input
                    type="text"
                    pInputText
                    [readonly]="isReadonlyUsage"
                    (keypress)="numberOnly($event)"
                    (keyup)="eXOactiveusers()"
                    formControlName="eXOActiveUsers" />
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
              </div>
              <div class="ui-g">
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  EXO active users % (must be > 25%)
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <div class="ui-inputgroup">
                    <input
                      type="text"
                      pInputText
                      (keypress)="numberOnly($event)"
                      readonly
                      formControlName="eXOActiveUsers25Per"
                      class="text-right" />
                    <span class="ui-inputgroup-addon">%</span>
                  </div>
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
              </div>
              <div class="ui-g">
                <div class="ui-g-12 ui-md-4 ui-lg-4">SfB Paid Entitlements</div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <input
                    type="text"
                    pInputText
                    (keypress)="numberOnly($event)"
                    [readonly]="isReadonlyUsage"
                    (keyup)="SfBactiveusers()"
                    formControlName="sfBPaidEntitlements" />
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
              </div>
              <div class="ui-g">
                <div class="ui-g-12 ui-md-4 ui-lg-4">SfB active users</div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <input
                    type="text"
                    pInputText
                    (keypress)="numberOnly($event)"
                    [readonly]="isReadonlyUsage"
                    (keyup)="SfBactiveusers()"
                    formControlName="sfBActiveUsers" />
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
              </div>
              <div class="ui-g">
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  SfB active users % (must be > 25%)
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <div class="ui-inputgroup">
                    <input
                      type="text"
                      pInputText
                      (keypress)="numberOnly($event)"
                      readonly
                      formControlName="sfBActiveUsers25Per"
                      class="text-right" />
                    <span class="ui-inputgroup-addon">%</span>
                  </div>
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
              </div>
              <div class="ui-g">
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  Teams Paid Entitlements
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <input
                    type="text"
                    pInputText
                    (keypress)="numberOnly($event)"
                    (keyup)="teamsactiveusers()"
                    [readonly]="isReadonlyUsage"
                    formControlName="teamsPaidEntitlements" />
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
              </div>
              <div class="ui-g">
                <div class="ui-g-12 ui-md-4 ui-lg-4">Teams active users</div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <input
                    type="text"
                    pInputText
                    (keypress)="numberOnly($event)"
                    (keyup)="teamsactiveusers()"
                    [readonly]="isReadonlyUsage"
                    formControlName="teamsactiveusers" />
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
              </div>
              <div class="ui-g">
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  Unused Teams Entitlements (must be > 1000)
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <input
                    type="text"
                    pInputText
                    (keypress)="numberOnly($event)"
                    readonly
                    formControlName="unusedTeamsEntitlements" />
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
              </div>
              <div class="ui-g">
                <div class="ui-g-12 ui-md-4 ui-lg-4">Teams active users %</div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <div class="ui-inputgroup">
                    <input
                      type="text"
                      pInputText
                      readonly
                      (keypress)="numberOnly($event)"
                      formControlName="teamsactiveusersPer"
                      class="text-right" />
                    <span class="ui-inputgroup-addon">%</span>
                  </div>
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
              </div>
              <div class="ui-g">
                <div class="ui-g-12 ui-md-4 ui-lg-4">ROI Computation</div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <input
                    type="text"
                    pInputText
                    (keypress)="numberOnly($event)"
                    [readonly]="isReadonlyUsage"
                    formControlName="rOIComputation" />
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
              </div>
              <div class="ui-g">
                <div class="ui-g-12 ui-md-4 ui-lg-4">Spo Entitlements</div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <input
                    type="text"
                    pInputText
                    (keypress)="numberOnly($event)"
                    (keyup)="spoactiveusers()"
                    [readonly]="isReadonlyUsage"
                    formControlName="spoEntitlements" />
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
              </div>
              <div class="ui-g">
                <div class="ui-g-12 ui-md-4 ui-lg-4">Spo Active Users</div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <input
                    type="text"
                    pInputText
                    (keypress)="numberOnly($event)"
                    (keyup)="spoactiveusers()"
                    [readonly]="isReadonlyUsage"
                    formControlName="spoActiveUsers" />
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
              </div>
              <div class="ui-g">
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  Spo Active Users (must be > 25%)
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <div class="ui-inputgroup">
                    <input
                      type="text"
                      pInputText
                      (keypress)="numberOnly($event)"
                      readonly
                      formControlName="spoactiveusersper"
                      class="text-right" />
                    <span class="ui-inputgroup-addon">%</span>
                  </div>
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
              </div>
              <div class="ui-g">
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  AADP Qualified Entitlements
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <input
                    type="text"
                    pInputText
                    (keypress)="numberOnly($event)"
                    (keyup)="aadp()"
                    [readonly]="isReadonlyUsage"
                    formControlName="aadpQualifiedEntitlements" />
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
              </div>
              <div class="ui-g">
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  AADP Active Entitlements
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <input
                    type="text"
                    pInputText
                    (keypress)="numberOnly($event)"
                    (keyup)="aadp()"
                    [readonly]="isReadonlyUsage"
                    formControlName="aadpActiveEntitlements" />
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
              </div>
              <div class="ui-g">
                <div class="ui-g-12 ui-md-4 ui-lg-4">AADP AEQE Percent</div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <div class="ui-inputgroup">
                    <input
                      type="text"
                      pInputText
                      (keypress)="numberOnly($event)"
                      readonly="true"
                      formControlName="aadpaeqePercent"
                      class="text-right" />
                    <span class="ui-inputgroup-addon">%</span>
                  </div>
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
              </div>
              <div class="ui-g">
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  Teams Meetings Qualified Entitlements
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <input
                    type="text"
                    pInputText
                    (keypress)="numberOnly($event)"
                    (keyup)="teamsMeetings()"
                    [readonly]="isReadonlyUsage"
                    formControlName="teamsMeetingsQualifiedEntitlements" />
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
              </div>
              <div class="ui-g">
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  Teams Meetings Active Entitlements
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <input
                    type="text"
                    pInputText
                    (keypress)="numberOnly($event)"
                    (keyup)="teamsMeetings()"
                    [readonly]="isReadonlyUsage"
                    formControlName="teamsMeetingsActiveEntitlements" />
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
              </div>
              <div class="ui-g">
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  Teams Meetings MAUQE Percent
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <div class="ui-inputgroup">
                    <input
                      type="text"
                      pInputText
                      (keypress)="numberOnly($event)"
                      readonly="true"
                      formControlName="teamsMeetingsMAUQEPercent"
                      class="text-right" />
                    <span class="ui-inputgroup-addon">%</span>
                  </div>
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
              </div>
            </div></form
        ></p-tabpanel>
        <p-tabpanel value="5">
          <div class="rtnav ui-g">
            <div class="ui-g-8 msgbox-8">
              @for (message of msgsEngDetails; track message) {
                <p-message [life]="3000" [text]="message.detail"></p-message>
              }
            </div>

            @if (!btnNavEngDetails) {
              <div class="ui-g-3"></div>
            }
            @if (btnNavEngDetails) {
              <div class="ui-g-3">
                <button
                  type="button"
                  pButton
                  (click)="editEngementDetailsCancel()"
                  class="ui-button-secondary flat fl-rt">
                  Cancel
                </button>
                <button
                  type="submit"
                  pButton
                  (click)="onSubmitEngagementDetails(formEngagement)"
                  class="flat btnmr fl-rt"
                  [disabled]="isBusy">
                  Save
                </button>
              </div>
            }
            <div class="ui-g-1 edit-history-icon">
              <span
                class="fa fa-pencil ico cpointer fl-rt"
                pTooltip="Edit"
                (click)="editEngagementDetails()"
                (keyup.enter)="editEngagementDetails()"
                tabindex="0"
                tooltipPosition="bottom"></span>
              @if (release === 'Prod') {
                <a
                  target="_blank"
                  href="https://msit.powerbi.com/groups/bb67cbd8-99ea-4206-8501-7536c68201a7/reports/94a5287e-f98e-4494-8a7d-7c8bc1fbb0f2/ReportSection8806268e87655e1f7814?filter=Master_Engagement/EngagementKey eq '{{
                    engementId
                  }}'">
                  <span
                    class="fa fa-history ico cpointer fl-rt"
                    pTooltip="History"
                    tooltipPosition="bottom">
                  </span>
                </a>
              }
              @if (release !== 'Prod') {
                <a
                  target="_blank"
                  href="https://msit.powerbi.com/groups/b7cf08d2-8c22-4aa9-9a79-f4a8cd991f77/reports/1c164c70-828c-401d-b87a-2c075eab2888/ReportSection8806268e87655e1f7814?filter=Master_Engagement/EngagementKey eq '{{
                    engementId
                  }}'">
                  <span
                    class="fa fa-history ico cpointer fl-rt"
                    pTooltip="History"
                    tooltipPosition="bottom">
                  </span>
                </a>
              }
            </div>
          </div>

          <form [formGroup]="formEngagement" #localForm="ngForm">
            <div class="readonlytbox">
              <div class="ui-g">
                <div class="ui-g-12 ui-md-3 ui-lg-3">Qualified Amount</div>
                <div class="ui-g-12 pr-0 ui-md-1 ui-lg-1">
                  @if (reducedForMcap) {
                    <span
                      class="fa pull-right fa-exclamation-circle ico cpointer fl-rt"
                      pTooltip="Payment reduced to conform to the program payment cap."
                      tooltipPosition="left"></span>
                  }
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <input
                    type="text"
                    pInputText
                    [readonly]="isReadonlyEng"
                    [disabled]="isReadonlyEng"
                    (keypress)="numberOnly($event)"
                    formControlName="qualifiedAmount" />
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
              </div>
              @if (
                (formEngagementDetails.controls['engagementType'].value ===
                  'Teams Meetings Workshop' ||
                  formEngagementDetails.controls['engagementType'].value ===
                    'Teams Meetings Workshop + US Incentive') &&
                incentiveEligible
              ) {
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Is Incentive Applied
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <p-radioButton
                      name="incentiveApplied"
                      value="true"
                      [(ngModel)]="appliedValue"
                      formControlName="incentiveApplied"
                      [disabled]="isReadonlyEng"
                      inputId="ing"></p-radioButton
                    ><label for="ing" class="ml-2">Yes</label>
                    <p-radioButton
                      name="incentiveApplied"
                      class="ml-4"
                      value="false"
                      [(ngModel)]="appliedValue"
                      formControlName="incentiveApplied"
                      [disabled]="isReadonlyEng"
                      inputId="ing"></p-radioButton
                    ><label for="ing" class="ml-2">No</label>
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
              }
              @if (
                (formEngagementDetails.controls['engagementType'].value ===
                  'Teams Meetings Workshop' ||
                  formEngagementDetails.controls['engagementType'].value ===
                    'Teams Meetings Workshop + US Incentive') &&
                appliedValue === 'true' &&
                incentiveEligible
              ) {
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">Incentive Amount</div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      (keypress)="numberOnly($event)"
                      [readonly]="isReadonlyEng"
                      [disabled]="isReadonlyEng"
                      formControlName="incentiveAmount" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
              }
              <div class="ui-g">
                <div class="ui-g-12 ui-md-4 ui-lg-4">Task Owner</div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <p-select
                    appendTo="body"
                    [options]="taskOwnerDrpdwn"
                    [readonly]="isReadonlyEng"
                    formControlName="taskOwner"
                    [disabled]="isReadonlyEng"
                    [class.readonlydd]="isReadonlyEng === true"
                    placeholder="--SELECT--"
                    optionLabel="taskOwner"></p-select>
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
              </div>
              <div class="ui-g">
                <div class="ui-g-12 ui-md-4 ui-lg-4">PMO Next Steps</div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <p-select
                    appendTo="body"
                    [options]="pmoNextStepStatus"
                    (onChange)="onPmoNextStepStatusChange($event)"
                    [readonly]="isReadonlyEng"
                    formControlName="pMONextSteps"
                    [disabled]="isReadonlyEng"
                    [class.readonlydd]="isReadonlyEng === true"
                    placeholder="--SELECT--"
                    dataKey="pmonextStepId"
                    optionLabel="pmoNextStepName"></p-select>
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
              </div>
              <div class="ui-g">
                <div class="ui-g-12 ui-md-4 ui-lg-4">L1 Internal Status</div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <p-select
                    appendTo="body"
                    [options]="l1InternalStatus1"
                    (onChange)="onL1InternalStatusChange($event)"
                    [readonly]="isReadonlyEng"
                    formControlName="t1InternalStatus"
                    [disabled]="isReadonlyEng"
                    [class.readonlydd]="isReadonlyEng === true"
                    placeholder="--SELECT--"
                    optionLabel="l1internalStatus"></p-select>
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
              </div>
              <div class="ui-g">
                <div class="ui-g-12 ui-md-4 ui-lg-4">Ops Status</div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <p-select
                    appendTo="body"
                    [options]="l2InternalStatus1"
                    [readonly]="isReadonlyEng"
                    formControlName="opsStatus"
                    dataKey="l2internalStatusId"
                    [disabled]="isReadonlyEng"
                    [class.readonlydd]="isReadonlyEng === true"
                    placeholder="--SELECT--"
                    optionLabel="l2internalStatus"></p-select>
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
              </div>
              <div class="ui-g">
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  Milestone Payment Status
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <p-select
                    appendTo="body"
                    [options]="milestonePaymentStatuses"
                    [readonly]="isReadonlyEng"
                    formControlName="milestonePaymentStatus"
                    dataKey="milestonePaymentStatusId"
                    optionValue="milestonePaymentStatusName"
                    [disabled]="isReadonlyEng"
                    [class.readonlydd]="isReadonlyEng === true"
                    placeholder="--SELECT--"
                    optionLabel="milestonePaymentStatusName"></p-select>
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
              </div>
              <div class="ui-g">
                <div class="ui-g-12 ui-md-4 ui-lg-4">Decline Reasons</div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <p-select
                    appendTo="body"
                    [options]="declineReason"
                    [readonly]="isReadonlyEng"
                    formControlName="declineReasons"
                    [disabled]="isReadonlyEng"
                    [class.readonlydd]="isReadonlyEng === true"
                    placeholder="--SELECT--"
                    optionLabel="declineReason"></p-select>
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
              </div>
              @if (isGsiWorkshop) {
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">MSX ID</div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      [disabled]="isReadonlyEng"
                      [readonly]="isReadonlyEng"
                      formControlName="msxid"
                      maxlength="20" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
              }
              <div class="ui-g">
                <div class="ui-g-12 ui-md-12 ui-lg-12">
                  <div class="hdbl">Key Dates</div>
                </div>
              </div>
              <div class="ui-g">
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  Business Days from Submission to Updated Status
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <input
                    type="text"
                    pInputText
                    (keypress)="numberOnly($event)"
                    [readonly]="isReadonlyEng"
                    [disabled]="isReadonlyEng"
                    formControlName="businessDays" />
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
              </div>
              <div class="ui-g">
                <div class="ui-g-12 ui-md-4 ui-lg-4">Eligible Date</div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <p-datepicker
                    appendTo="body"
                    formControlName="eligibleDate"
                    dateFormat="mm/dd/yy"
                    placeholder="mm/dd/yy"
                    [readonlyInput]="true"
                    [defaultDate]="maxYearDate"
                    [showOnFocus]="false"
                    [iconDisplay]="'input'"
                    [showIcon]="isReadonlyEng === false"
                    [class.readonlycaltb]="isReadonlyEng === true"
                    [disabled]="isReadonlyEng">
                  </p-datepicker>
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
              </div>
              <div class="ui-g">
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  Days since customer confirmation agreement email sent (cancel
                  after 30 days)
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <input
                    type="text"
                    pInputText
                    (keypress)="numberOnly($event)"
                    readonly
                    formControlName="daysSinceCustomer" />
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
              </div>
              <div class="ui-g">
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  30 Day Reminder Sent Date
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <p-datepicker
                    appendTo="body"
                    formControlName="thirtyDayReminderSentDate"
                    dateFormat="mm/dd/yy"
                    placeholder="mm/dd/yy"
                    [readonlyInput]="true"
                    [defaultDate]="maxYearDate"
                    [showOnFocus]="false"
                    [iconDisplay]="'input'"
                    [showIcon]="isReadonlyEng === false"
                    [class.readonlycaltb]="isReadonlyEng === true"
                    [disabled]="isReadonlyEng">
                  </p-datepicker>
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
              </div>
              @if (!this.isGsiWorkshop) {
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    30 day Expiration Date
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <p-datepicker
                      appendTo="body"
                      formControlName="e30dayExpirationDate"
                      dateFormat="mm/dd/yy"
                      placeholder="mm/dd/yy"
                      [readonlyInput]="true"
                      [defaultDate]="maxYearDate"
                      [showOnFocus]="false"
                      [iconDisplay]="'input'"
                      [showIcon]="isReadonlyEng === false"
                      [class.readonlycaltb]="isReadonlyEng === true"
                      [disabled]="isReadonlyEng">
                    </p-datepicker>
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
              }
              <div class="ui-g">
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  90 days Expiration Date
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <p-datepicker
                    appendTo="body"
                    formControlName="day90ExpirationDate"
                    dateFormat="mm/dd/yy"
                    placeholder="mm/dd/yy"
                    [readonlyInput]="true"
                    [defaultDate]="maxYearDate"
                    [showOnFocus]="false"
                    [iconDisplay]="'input'"
                    [showIcon]="true"
                    [class.readonlycaltb]="false"
                    [disabled]="isReadonlyEng">
                  </p-datepicker>
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
              </div>
              <div class="ui-g">
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  Days Left From 90 Days Expiration Date
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <input
                    type="text"
                    pInputText
                    (keypress)="numberOnly($event)"
                    readonly
                    formControlName="daysLeftFromDay90ExpirationDate"
                    [disabled]="isReadonlyEng" />
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
              </div>
              <div class="ui-g">
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  Date Engagement Cancelled
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <input
                    type="text"
                    pInputText
                    (keypress)="numberOnly($event)"
                    readonly
                    formControlName="cancelledDate"
                    [disabled]="isReadonlyEng" />
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
              </div>
              <div class="ui-g">
                <div class="ui-g-12 ui-md-4 ui-lg-4">Engagement Extended</div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  @if (isReadonlyEng) {
                    <div>
                      <input type="checkbox" formControlName="isExtended" />
                    </div>
                  }
                  @if (!isReadonlyEng) {
                    <div>
                      <input
                        type="checkbox"
                        formControlName="isExtended"
                        (click)="onCheckedEngagementExtended()" />
                    </div>
                  }
                </div>
              </div>
              <div class="ui-g">
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  Extended Expiration Date
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <p-datepicker
                    appendTo="body"
                    formControlName="extendedDate"
                    dateFormat="mm/dd/yy"
                    [ngClass]="{
                      extend_expiration_calendar:
                        localForm.submitted &&
                        formEngagement.get('extendedDate')?.invalid &&
                        isEngagementExtendedEnable &&
                        !isReadonlyEng
                    }"
                    [required]="isEngagementExtendedEnable"
                    [minDate]="dateTime"
                    [class.readonlycaltb]="isReadonlyEng"
                    [disabled]="isReadonlyEng"
                    hourFormat="12"
                    inputId="basic"
                    [readonlyInput]="true"
                    [showOnFocus]="!isReadonlyEng"
                    [showIcon]="!isReadonlyEng"
                    [iconDisplay]="'input'"
                    placeholder="Click to select date"></p-datepicker>
                </div>
                @if (
                  !isReadonlyEng &&
                  localForm.submitted &&
                  formEngagement.get('extendedDate')?.invalid &&
                  isEngagementExtendedEnable
                ) {
                  <div
                    class="ui-g-12 ui-md-4 ui-lg-4"
                    [ngClass]="{
                      'extend-expiration-fails':
                        localForm.submitted &&
                        formEngagement.get('extendedDate')?.invalid
                    }">
                    <span>Please enter Extended Expiration Date</span>
                  </div>
                }
                <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
              </div>
              <div class="ui-g">
                <div class="ui-g-12 ui-md-4 ui-lg-4">Milestone 2 End Date</div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <p-datepicker
                    appendTo="body"
                    formControlName="activityEligibilityEndDate"
                    dateFormat="mm/dd/yy"
                    placeholder="mm/dd/yy"
                    [readonlyInput]="true"
                    [defaultDate]="maxYearDate"
                    [showOnFocus]="false"
                    [showIcon]="isReadonlyEng === false"
                    [disabled]="isReadonlyEng"
                    [iconDisplay]="'input'"
                    [class.readonlycaltb]="false">
                  </p-datepicker>
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
              </div>
              <div class="ui-g">
                <div class="ui-g-12 ui-md-4 ui-lg-4">Committed Date</div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <p-datepicker
                    appendTo="body"
                    formControlName="committedDate"
                    dateFormat="mm/dd/yy"
                    placeholder="mm/dd/yy"
                    [readonlyInput]="true"
                    [defaultDate]="maxYearDate"
                    [showOnFocus]="false"
                    [showIcon]="isReadonlyEng === false"
                    [iconDisplay]="'input'"
                    [class.readonlycaltb]="isReadonlyEng === true"
                    [disabled]="isReadonlyEng">
                  </p-datepicker>
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
              </div>
              <div class="ui-g">
                <div class="ui-g-12 ui-md-4 ui-lg-4">Decline Email Sent</div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <p-datepicker
                    appendTo="body"
                    formControlName="declineEmailSent"
                    dateFormat="mm/dd/yy"
                    placeholder="mm/dd/yy"
                    [readonlyInput]="true"
                    [showOnFocus]="false"
                    [showIcon]="isReadonlyEng === false"
                    [iconDisplay]="'input'"
                    [class.readonlycaltb]="isReadonlyEng === true"
                    [disabled]="isReadonlyEng"
                    [defaultDate]="maxYearDate">
                  </p-datepicker>
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
              </div>
              @if (hasCustomerAcknowledgement) {
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Customer Acknowledgement Date
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <p-datepicker
                      appendTo="body"
                      formControlName="committedEmailSent"
                      dateFormat="mm/dd/yy"
                      placeholder="mm/dd/yy"
                      [readonlyInput]="true"
                      [showOnFocus]="false"
                      [showIcon]="isReadonlyEng === false"
                      [iconDisplay]="'input'"
                      [class.readonlycaltb]="isReadonlyEng === true"
                      [disabled]="isReadonlyEng"
                      [defaultDate]="maxYearDate">
                    </p-datepicker>
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <button
                      type="button"
                      pButton
                      (click)="uploadOpenNav()"
                      pTooltip="Upload or View"
                      tooltipPosition="top"
                      class="ui-button-info btnpad btnmr">
                      Customer Acknowledgement
                    </button>
                    <a
                      (click)="downloadCustackemtem()"
                      pTooltip="Download Template"
                      tooltipPosition="top"
                      (keyup.enter)="downloadCustackemtem()"
                      tabindex="0"
                      >Download</a
                    >
                  </div>
                </div>
              }
              @if (
                caDeclinereason &&
                showCustomerAckRejectedReason &&
                hasCustomerAcknowledgement
              ) {
                <div class="ui-g min-height">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Customer Acknowledgement Decline Reason
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <span>{{ caDeclinereason }}</span>
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
              }
              @if (hasCustomerAcknowledgement) {
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    Customer Acknowledgement Status
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4">
                    <input
                      type="text"
                      pInputText
                      readonly
                      formControlName="customerAckStatus" />
                  </div>
                  <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
                </div>
              }

              <div class="ui-g">
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  Days since Committed Email Sent (cancel after 90 days)
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <input
                    type="text"
                    pInputText
                    (keypress)="numberOnly($event)"
                    readonly
                    formControlName="daysSinceCommittedEmailSent" />
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
              </div>
              <div class="ui-g">
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  90 Day Reminder Sent Date
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <p-datepicker
                    appendTo="body"
                    formControlName="reminderSentDate"
                    dateFormat="mm/dd/yy"
                    placeholder="mm/dd/yy"
                    [readonlyInput]="true"
                    [showOnFocus]="false"
                    [showIcon]="isReadonlyEng === false"
                    [iconDisplay]="'input'"
                    [class.readonlycaltb]="isReadonlyEng === true"
                    [disabled]="isReadonlyEng"
                    [defaultDate]="maxYearDate">
                  </p-datepicker>
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
              </div>
              <div class="ui-g">
                <div class="ui-g-12 ui-md-4 ui-lg-4">Funding Type</div>
                <div class="ui-g-12 ui-md-4 ui-lg-4">
                  <input
                    type="text"
                    pInputText
                    readonly
                    formControlName="fundingType" />
                </div>
                <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
              </div>
            </div>
          </form>
        </p-tabpanel>
        <p-tabpanel value="6">
          <div class="rtnav ui-g">
            <div class="ui-g-8 msgbox-8">
              @for (message of msgsPoe; track message) {
                <p-message [life]="3000" [text]="message.detail"></p-message>
              }
            </div>
            @if (!btnNavPoe) {
              <div class="ui-g-3"></div>
            }
            @if (btnNavPoe) {
              <div class="ui-g-3">
                <button
                  type="button"
                  pButton
                  (click)="editPoeInformationCancel()"
                  class="ui-button-secondary flat fl-rt">
                  Cancel
                </button>
                <button
                  type="submit"
                  pButton
                  (click)="onSubmitPOEInformation()"
                  class="flat btnmr fl-rt">
                  Save
                </button>
              </div>
            }
            <div class="ui-g-1 edit-history-icon">
              <button
                class="fa fa-pencil ico cpointer fl-rt poeinfo-edit-button"
                pTooltip="Edit"
                (click)="editPoeInformation()"
                tooltipPosition="bottom">
                &nbsp;
              </button>
              @if (release === 'Prod') {
                <a
                  target="_blank"
                  href="https://msit.powerbi.com/groups/bb67cbd8-99ea-4206-8501-7536c68201a7/reports/94a5287e-f98e-4494-8a7d-7c8bc1fbb0f2/ReportSectionf24c54ede7d280c05cb2?filter=Master_Engagement/EngagementKey eq '{{
                    engementId
                  }}'">
                  <span
                    class="fa fa-history ico cpointer fl-rt"
                    pTooltip="History"
                    tooltipPosition="bottom"></span>
                </a>
              }
              @if (release !== 'Prod') {
                <a
                  target="_blank"
                  href="https://msit.powerbi.com/groups/b7cf08d2-8c22-4aa9-9a79-f4a8cd991f77/reports/1c164c70-828c-401d-b87a-2c075eab2888/ReportSectionf24c54ede7d280c05cb2?filter=Master_Engagement/EngagementKey eq '{{
                    engementId
                  }}'">
                  <span
                    class="fa fa-history ico cpointer fl-rt"
                    pTooltip="History"
                    tooltipPosition="bottom"></span>
                </a>
              }
            </div>
          </div>
          <form [formGroup]="formPOEInformation">
            <div class="readonlytbox">
              <div class="ui-g">
                <div class="ui-g-12 ui-md-8 ui-lg-8">
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-6 ui-lg-6">
                      Scheduled Activity Date
                    </div>
                    <div class="ui-g-12 ui-md-6 ui-lg-6">
                      <p-datepicker
                        appendTo="body"
                        formControlName="scheduledActivityDate"
                        dateFormat="mm/dd/yy"
                        placeholder="mm/dd/yy"
                        [readonlyInput]="true"
                        [showOnFocus]="false"
                        [showIcon]="isReadonlyPOE === false"
                        [iconDisplay]="'input'"
                        [class.readonlycaltb]="isReadonlyPOE === true"
                        [defaultDate]="maxYearDate">
                      </p-datepicker>
                    </div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-6 ui-lg-6">Expected POE Date</div>
                    <div class="ui-g-12 ui-md-6 ui-lg-6">
                      <p-datepicker
                        appendTo="body"
                        formControlName="expectedPOEDate"
                        dateFormat="mm/dd/yy"
                        [readonlyInput]="true"
                        [showOnFocus]="false"
                        [showIcon]="isReadonlyPOE === false"
                        [iconDisplay]="'input'"
                        [class.readonlycaltb]="isReadonlyPOE === true"
                        [defaultDate]="maxYearDate"></p-datepicker>
                    </div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-6 ui-lg-6">
                      Month Payment Submitted
                    </div>
                    <div class="ui-g-12 ui-md-6 ui-lg-6">
                      <p-select
                        appendTo="body"
                        [options]="monthList"
                        [readonly]="isReadonlyPOE"
                        [class.readonlydd]="isReadonlyPOE === true"
                        formControlName="expectedPaymentMonth"
                        placeholder="--SELECT--"
                        optionLabel="fiscal_Month"></p-select>
                    </div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-6 ui-lg-6">
                      Confidence (High, Medium, Low, Received)
                    </div>
                    <div class="ui-g-12 ui-md-6 ui-lg-6">
                      <p-select
                        appendTo="body"
                        [options]="confidence"
                        [readonly]="isReadonlyPOE"
                        [class.readonlydd]="isReadonlyPOE === true"
                        formControlName="confidenceHighMediumLowReceived"
                        placeholder="--SELECT--"
                        optionLabel="confidence"></p-select>
                    </div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-6 ui-lg-6">
                      {{ workshopDate_Label }}
                    </div>
                    <div class="ui-g-12 ui-md-6 ui-lg-6">
                      <p-datepicker
                        appendTo="body"
                        formControlName="workshopCompletionDate"
                        dateFormat="mm/dd/yy"
                        [readonlyInput]="true"
                        [showOnFocus]="false"
                        [showIcon]="isReadonlyPOE === false"
                        [iconDisplay]="'input'"
                        [class.readonlycaltb]="isReadonlyPOE === true"
                        [defaultDate]="maxYearDate"></p-datepicker>
                    </div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-6 ui-lg-6">
                      {{ workshopTypeCompleted_Label }}
                    </div>
                    <div class="ui-g-12 ui-md-6 ui-lg-6">
                      <p-select
                        appendTo="body"
                        [options]="engagementType1"
                        [readonly]="isReadonlyPOE"
                        [class.readonlydd]="isReadonlyPOE === true"
                        formControlName="workshopTypeCompleted"
                        placeholder="--SELECT--"
                        optionLabel="engagementType"></p-select>
                    </div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-6 ui-lg-6">
                      Partner Statement Sent Date
                    </div>
                    <div class="ui-g-12 ui-md-6 ui-lg-6">
                      <p-datepicker
                        appendTo="body"
                        formControlName="partnerStatementSentDate"
                        dateFormat="mm/dd/yy"
                        [readonlyInput]="true"
                        [showOnFocus]="false"
                        [showIcon]="isReadonlyPOE === false"
                        [iconDisplay]="'input'"
                        [class.readonlycaltb]="isReadonlyPOE === true"
                        [defaultDate]="maxYearDate">
                      </p-datepicker>
                    </div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-6 ui-lg-6">
                      Payment Document Number
                    </div>
                    <div class="ui-g-12 ui-md-6 ui-lg-6">
                      <input
                        type="text"
                        pInputText
                        [readonly]="isReadonlyPOE"
                        formControlName="statementNumber" />
                    </div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-6 ui-lg-6">
                      {{ invoiceNumber_Label }}
                    </div>
                    <div class="ui-g-12 ui-md-6 ui-lg-6">
                      <input
                        type="text"
                        pInputText
                        [readonly]="isReadonlyPOE"
                        formControlName="mSInvoiceNumber" />
                    </div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-6 ui-lg-6">
                      {{ invoicePaidDate_Label }}
                    </div>
                    <div class="ui-g-12 ui-md-6 ui-lg-6">
                      <p-datepicker
                        appendTo="body"
                        formControlName="mSInvoicePaidDate"
                        dateFormat="mm/dd/yy"
                        [readonlyInput]="true"
                        [showOnFocus]="false"
                        [showIcon]="isReadonlyPOE === false"
                        [iconDisplay]="'input'"
                        [class.readonlycaltb]="isReadonlyPOE === true"
                        [defaultDate]="maxYearDate"></p-datepicker>
                    </div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-6 ui-lg-6">
                      {{ transactionId_Label }}
                    </div>
                    <div class="ui-g-12 ui-md-6 ui-lg-6">
                      <input
                        type="text"
                        pInputText
                        [readonly]="isReadonlyPOE"
                        formControlName="paymentCentralTransactionID" />
                    </div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-6 ui-lg-6">
                      Partner Payment Profile Status
                    </div>
                    <div class="ui-g-12 ui-md-6 ui-lg-6">
                      <p-radioButton
                        name="partnerPaymentProfileStatus"
                        value="true"
                        formControlName="partnerPaymentProfileStatus"
                        inputId="ppS"></p-radioButton
                      ><label for="ppS" class="ml-2">Yes</label>
                      <p-radioButton
                        name="partnerPaymentProfileStatus"
                        class="ml-4"
                        value="false"
                        formControlName="partnerPaymentProfileStatus"
                        inputId="ppS"></p-radioButton
                      ><label for="ppS" class="ml-2">No</label>
                    </div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-6 ui-lg-6">Supplier ID</div>
                    <div class="ui-g-12 ui-md-6 ui-lg-6">
                      <input
                        type="text"
                        pInputText
                        [readonly]="isReadonlyPOE"
                        formControlName="supplierID" />
                    </div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-6 ui-lg-6">Payee ID</div>
                    <div class="ui-g-12 ui-md-6 ui-lg-6">
                      <input
                        type="text"
                        pInputText
                        readonly
                        formControlName="payeeID" />
                    </div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-6 ui-lg-6">Payee Name</div>
                    <div class="ui-g-12 ui-md-6 ui-lg-6">
                      <input
                        type="text"
                        pInputText
                        readonly
                        formControlName="payeeName" />
                    </div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-6 ui-lg-6">Agreement</div>
                    <div class="ui-g-12 ui-md-6 ui-lg-6">
                      <p-radioButton
                        name="agreement"
                        value="true"
                        formControlName="agreement"
                        inputId="agre"></p-radioButton
                      ><label for="agre" class="ml-2">Yes</label>
                      <p-radioButton
                        class="ml-4"
                        name="agreement"
                        value="false"
                        formControlName="agreement"
                        inputId="agre"></p-radioButton
                      ><label for="agre" class="ml-2">No</label>
                    </div>
                  </div>
                  <div class="ui-g">
                    <div class="ui-g-12 ui-md-6 ui-lg-6">Submitted Date</div>
                    <div class="ui-g-12 ui-md-6 ui-lg-6">
                      <input
                        type="text"
                        pInputText
                        readonly
                        formControlName="submittedDate" />
                    </div>
                  </div>
                  @if (
                    programTypeId === ProgramType.MSSP ||
                    programTypeId === ProgramType.Operator
                  ) {
                    <div class="ui-g">
                      <div class="ui-g-12 ui-md-6 ui-lg-6">
                        Date Milestone 1 Completed
                      </div>
                      <div class="ui-g-12 ui-md-6 ui-lg-6">
                        <p-datepicker
                          appendTo="body"
                          [readonlyInput]="true"
                          formControlName="milestoneOneCompletedDate"
                          dateFormat="mm/dd/yy"
                          [showOnFocus]="false"
                          [showIcon]="isReadonlyPOE === false"
                          [iconDisplay]="'input'"
                          [class.readonlycaltb]="isReadonlyPOE === true"
                          [defaultDate]="maxYearDate"
                          placeholder="mm/dd/yy"></p-datepicker>
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>
          </form>
        </p-tabpanel>
        <p-tabpanel value="7">
          <app-milestone2-payment-special-investment
            [engagementId]="this.engementId"
            [isOptOutPartner]="this.isOptOutPartner"
            [isPartnerBlocked]="this.isPartnerBlocked"
            [activityType]="
              this.formEngagementDetails.controls['engagementType'].value
            "
            [partnerMpnid]="this.partnerMpnid"
            [programTypeId]="this.programTypeId">
          </app-milestone2-payment-special-investment
        ></p-tabpanel>
        <p-tabpanel value="8">
          <app-m2-percentage-payment-special-investment
            [engagementId]="this.engementId"
            [isOptOutPartner]="this.isOptOutPartner"
            [isPartnerBlocked]="this.isPartnerBlocked"
            [activityType]="
              this.formEngagementDetails.controls['engagementType'].value
            "
            [partnerMpnid]="this.partnerMpnid"
            [programTypeId]="this.programTypeId">
          </app-m2-percentage-payment-special-investment>
        </p-tabpanel>
        <p-tabpanel value="9">
          <div class="rtnav ui-g">
            <div class="ui-g-6 msgbox-6">
              @for (message of msgsPoeSurvey; track message) {
                <p-message [life]="3000" [text]="message.detail"></p-message>
              }
            </div>
            @if (!btnNavPoeSurvey) {
              <div class="ui-g-5"></div>
            }
            @if (btnNavPoeSurvey) {
              <div class="ui-g-5">
                <button
                  type="button"
                  pButton
                  (click)="editPoeSurveyCancel()"
                  class="ui-button-secondary flat fl-rt">
                  Cancel
                </button>
                <button
                  type="submit"
                  pButton
                  (click)="onSubmitPOESurvey()"
                  class="flat btnmr fl-rt">
                  Save
                </button>
              </div>
            }
            <div class="ui-g-1 edit-history-icon">
              <span
                class="fa fa-pencil ico cpointer fl-rt"
                pTooltip="Edit"
                (click)="editPoeSurvey()"
                (keydown.enter)="editPoeSurvey()"
                tabindex="0"
                tooltipPosition="bottom"></span>
            </div>
          </div>
          <form [formGroup]="formPOESurvey">
            <div class="readonlytbox">
              <div class="edittablebdr">
                <table cellpadding="0" cellspacing="0">
                  <tr>
                    <th style="width: 25%">POE Status</th>
                    <th style="width: 25%">POE Document Submitted Date</th>
                    <th style="width: 25%">POE Completion Date</th>
                    <th style="width: 25%"></th>
                  </tr>
                  <tr>
                    <td>
                      <p-select
                        appendTo="body"
                        [options]="poeStatus"
                        [readonly]="isReadonlyPOESurvey"
                        [class.readonlydd]="isReadonlyPOESurvey === true"
                        formControlName="PoeStatus1"
                        placeholder="--SELECT--"
                        optionLabel="poeStatusName"></p-select>
                    </td>
                    <td>
                      <p-datepicker
                        appendTo="body"
                        [readonlyInput]="true"
                        formControlName="poeDocumentSubmittedDate"
                        dateFormat="mm/dd/yy"
                        [showOnFocus]="false"
                        [showIcon]="isReadonlyPOESurvey === false"
                        [iconDisplay]="'input'"
                        [class.readonlycaltb]="isReadonlyPOESurvey === true"
                        [defaultDate]="maxYearDate">
                      </p-datepicker>
                    </td>
                    <td>
                      <p-datepicker
                        appendTo="body"
                        [readonlyInput]="true"
                        formControlName="pOECompletionDate"
                        dateFormat="mm/dd/yy"
                        [showOnFocus]="false"
                        [showIcon]="isReadonlyPOESurvey === false"
                        [iconDisplay]="'input'"
                        [class.readonlycaltb]="isReadonlyPOESurvey === true"
                        [defaultDate]="maxYearDate"></p-datepicker>
                    </td>
                    <td></td>
                  </tr>
                </table>
              </div>
              <div class="edittablebdr">
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-12 ui-lg-12">
                    <div class="hdbl">Summary</div>
                  </div>
                </div>

                <table cellpadding="0" cellspacing="0">
                  <tr>
                    <th style="width: 10%"></th>
                    <th style="width: 5%"></th>
                    <th style="width: 10%">Survey Name</th>
                    <th style="width: 10%">Type</th>
                    <th style="width: 10%">Created Date</th>
                    <th style="width: 15%">Survey Date</th>
                    <th style="width: 15%">Status</th>
                    <th style="width: 25%">Reason</th>
                  </tr>
                  <tr>
                    <td>
                      <a
                        class="cpointer"
                        (click)="cusSurveyResponse()"
                        (keydown.enter)="cusSurveyResponse()"
                        tabindex="0"
                        >+ Response</a
                      >
                    </td>
                    <td>
                      <span
                        class="fa fa-download ico cpointer"
                        pTooltip="Download"
                        (click)="cusSurveyResponseDownload('Customer')"
                        (keydown.enter)="cusSurveyResponseDownload('Customer')"
                        tabindex="0"
                        tooltipPosition="bottom"></span>
                    </td>
                    <td>
                      {{ formPOESurvey.controls['customerSurveyName'].value }}
                    </td>
                    <td>{{ formPOESurvey.controls['customertype'].value }}</td>
                    <td>
                      {{
                        formPOESurvey.controls['customerSurveyCreatedDate']
                          .value | date: 'MM/dd/yyyy'
                      }}
                    </td>
                    <td>
                      <p-datepicker
                        appendTo="body"
                        [readonlyInput]="true"
                        formControlName="customerPOESurveyDate"
                        dateFormat="mm/dd/yy"
                        [showOnFocus]="false"
                        [showIcon]="isReadonlyPOESurvey === false"
                        [iconDisplay]="'input'"
                        [class.readonlycaltb]="isReadonlyPOESurvey === true"
                        [defaultDate]="maxYearDate">
                      </p-datepicker>
                    </td>
                    <td>
                      <p-select
                        appendTo="body"
                        [options]="partnerPOESurveyStatus"
                        [readonly]="isReadonlyPOESurvey"
                        [class.readonlydd]="isReadonlyPOESurvey === true"
                        formControlName="customerPOESurveyStatus"
                        placeholder="--SELECT--"
                        optionLabel="poeSurveyStatusName"></p-select>
                    </td>
                    <td>
                      @if (canShowCustomerSurveyRejection) {
                        <span>{{ customerSurveyRejectionReason }}</span>
                      }
                    </td>
                  </tr>
                  <tr>
                    @if (
                      isCusSurveyResponse && cusPoeSurveyResponse.length > 0
                    ) {
                      <td colspan="8" class="bgtd">
                        <table class="reptable" cellpadding="0" cellspacing="0">
                          <tr>
                            <th>Ques#</th>
                            <th>Questions</th>
                            <th>Response</th>
                          </tr>
                          @for (
                            cusPoeSurveyResponse of cusPoeSurveyResponse;
                            track cusPoeSurveyResponse
                          ) {
                            <tr>
                              <td>{{ cusPoeSurveyResponse.questionNo }}</td>
                              <td>{{ cusPoeSurveyResponse.questions }}</td>
                              <td>{{ cusPoeSurveyResponse.responses }}</td>
                            </tr>
                          }
                        </table>
                      </td>
                    }
                  </tr>
                  <tr>
                    <td>
                      <a
                        class="cpointer"
                        (click)="parSurveyResponse()"
                        (keydown.enter)="parSurveyResponse()"
                        tabindex="0"
                        >+ Response</a
                      >
                    </td>

                    <td>
                      <span
                        class="fa fa-download ico cpointer"
                        pTooltip="Download"
                        (click)="cusSurveyResponseDownload('Partner')"
                        (keydown.enter)="cusSurveyResponseDownload('Partner')"
                        tabindex="0"
                        tooltipPosition="bottom"></span>
                    </td>
                    <td>
                      {{ formPOESurvey.controls['partnerSurveyName'].value }}
                    </td>
                    <td>{{ formPOESurvey.controls['partnerType'].value }}</td>
                    <td>
                      {{
                        formPOESurvey.controls['partnerSurveyCreatedDate'].value
                          | date: 'MM/dd/yyyy'
                      }}
                    </td>
                    <td>
                      <p-datepicker
                        appendTo="body"
                        formControlName="partnerPOESurveyDate"
                        dateFormat="mm/dd/yy"
                        [readonlyInput]="true"
                        [showOnFocus]="false"
                        [showIcon]="isReadonlyPOESurvey === false"
                        [iconDisplay]="'input'"
                        [class.readonlycaltb]="isReadonlyPOESurvey === true"
                        [defaultDate]="maxYearDate"></p-datepicker>
                    </td>
                    <td>
                      <p-select
                        appendTo="body"
                        [options]="partnerPOESurveyStatus"
                        [readonly]="isReadonlyPOESurvey"
                        [class.readonlydd]="isReadonlyPOESurvey === true"
                        formControlName="partnerPOESurveyStatus"
                        placeholder="--SELECT--"
                        optionLabel="poeSurveyStatusName"></p-select>
                    </td>
                    <td></td>
                  </tr>
                  <tr>
                    @if (
                      isParSurveyResponse && parPoeSurveyResponse.length > 0
                    ) {
                      <td colspan="8" class="bgtd">
                        <table class="reptable" cellpadding="0" cellspacing="0">
                          <tr>
                            <th>Ques#</th>
                            <th>Questions</th>
                            <th>Response</th>
                          </tr>
                          @for (
                            poeSurveyResponse of parPoeSurveyResponse;
                            track poeSurveyResponse
                          ) {
                            <tr>
                              <td>{{ poeSurveyResponse.questionNo }}</td>
                              <td>{{ poeSurveyResponse.questions }}</td>
                              <td>{{ poeSurveyResponse.responses }}</td>
                            </tr>
                          }
                        </table>
                      </td>
                    }
                  </tr>
                </table>
              </div>

              <div class="edittablebdr">
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-12 ui-lg-12 poe-doc-head">
                    <div class="hdbl">Required Documentation</div>
                    <div>
                      <button
                        type="button"
                        pButton
                        (click)="
                          onPoeDocumentUploadClick(documentType.POEInvoice)
                        "
                        pTooltip="Upload or View"
                        tooltipPosition="top"
                        class="ui-button-info btnpad btnmr">
                        Add POE Invoice
                      </button>
                      <button
                        type="button"
                        pButton
                        (click)="
                          onPoeDocumentUploadClick(documentType.POEDocument)
                        "
                        pTooltip="Upload or View"
                        tooltipPosition="top"
                        class="ui-button-info btnpad btnmr">
                        Add Findings & Recommendation
                      </button>
                    </div>
                  </div>
                </div>

                <p-table [value]="poeDocHyperLinks">
                  <ng-template #header let-columns>
                    <tr>
                      <th style="width: 20%">Document Name</th>
                      <th style="width: 10%">Download</th>
                      <th style="width: 10%">Preview</th>
                      <th style="width: 15%">Upload Date</th>
                      <th style="width: 15%">Type</th>
                      <th style="width: 20%">Status</th>
                      <th style="width: 30%">Reason</th>
                    </tr>
                  </ng-template>
                  <ng-template #body let-rowData>
                    <tr>
                      <td>
                        <a
                          target="_blank"
                          class="doc-name"
                          href="{{ rowData.poeDocFilePath }}"
                          >{{ rowData.poeDocName }}</a
                        >
                      </td>
                      @if (
                        rowData.poeDocName !== invoiceDocument ||
                        (rowData.poeDocName === invoiceDocument &&
                          !canShowInvoicePreview(rowData.poeDocFilePath))
                      ) {
                        <td>
                          <span
                            class="fa fa-download ico cpointer"
                            pTooltip="Download"
                            (click)="downloadPOE(rowData)"
                            tooltipPosition="bottom"
                            (keydown.enter)="downloadPOE(rowData)"
                            tabindex="0"></span>
                        </td>
                      }
                      @if (
                        rowData.poeDocName !== invoiceDocument ||
                        (rowData.poeDocName === invoiceDocument &&
                          !canShowInvoicePreview(rowData.poeDocFilePath))
                      ) {
                        <td>
                          <a
                            class="ml-2"
                            (click)="previewInvoice(rowData)"
                            (keyup.enter)="previewInvoice(rowData)"
                            tabindex="0">
                            <i class="fa fa-file fa-lg" pTooltip="Preview"></i>
                          </a>
                        </td>
                      }
                      @if (
                        rowData.poeDocName === invoiceDocument &&
                        canShowInvoicePreview(rowData.poeDocFilePath)
                      ) {
                        <td>
                          <span
                            class="fa fa-download ico cpointer"
                            pTooltip="Download"
                            (click)="downloadPOE(rowData)"
                            (keydown.enter)="downloadPOE(rowData)"
                            tabindex="0"
                            tooltipPosition="bottom"></span>
                        </td>
                      }
                      @if (
                        rowData.poeDocName === invoiceDocument &&
                        canShowInvoicePreview(rowData.poeDocFilePath)
                      ) {
                        <td>
                          <a
                            class="ml-2"
                            (click)="previewInvoice(rowData)"
                            (keyup.enter)="previewInvoice(rowData)"
                            tabindex="0">
                            <i class="fa fa-file fa-lg" pTooltip="Preview"></i
                          ></a>
                        </td>
                      }
                      <td>{{ rowData.uploadDate | date: 'MM/dd/yyyy' }}</td>
                      <td>
                        {{ checkPoeDocumentType(rowData.poeDocName) }}
                      </td>
                      @if (rowData.poeDocName !== invoiceDocument) {
                        <td>
                          <p-select
                            appendTo="body"
                            [options]="pOEDOCstatus1"
                            [readonly]="isReadonlyPOESurvey"
                            [class.readonlydd]="isReadonlyPOESurvey === true"
                            formControlName="poeDOCstatusCn"
                            placeholder="--SELECT--"
                            optionLabel="poeDocStatusName"></p-select>
                        </td>
                      }
                      @if (rowData.poeDocName === invoiceDocument) {
                        <td>
                          <p-select
                            appendTo="body"
                            [options]="PoeInvoiceStatus"
                            [readonly]="isReadonlyPOESurvey"
                            [class.readonlydd]="isReadonlyPOESurvey === true"
                            formControlName="poeInvoicestatus"
                            placeholder="--SELECT--"
                            optionLabel="poeInvoiceStatusName"></p-select>
                        </td>
                      }
                      <td>
                        @if (rowData.reasons) {
                          <span>{{ getReasons(rowData.reasons) }}</span>
                        }
                      </td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
              <div class="edittablebdr">
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-12 ui-lg-12">
                    <div class="hdbl">Saved Documents</div>
                  </div>
                </div>

                <p-table
                  [value]="poeHistoryDocuments"
                  [paginator]="true"
                  [rows]="historyTableRow"
                  [alwaysShowPaginator]="false">
                  <ng-template #header let-columns>
                    <tr>
                      <th style="width: 25%">Document Name</th>
                      <th style="width: 15%">Preview</th>
                      <th style="width: 15%">Upload Date</th>
                      <th style="width: 15%">Type</th>
                      <th style="width: 15%">Status</th>
                      <th style="width: 35%">Reason</th>
                    </tr>
                  </ng-template>
                  <ng-template #body let-rowData>
                    <tr>
                      <td>
                        @if (rowData.poeDocFilePath) {
                          <a
                            target="_blank"
                            href="{{ rowData.poeDocFilePath }}"
                            >{{ rowData.fileName }}</a
                          >
                        }
                        @if (!rowData.poeDocFilePath) {
                          <span>{{ rowData.poeDocName }}</span>
                        }
                      </td>
                      <td>
                        @if (rowData.poeDocFilePath) {
                          <a
                            class="ml-2"
                            (click)="previewHistoryDocument(rowData)"
                            (keyup.enter)="previewHistoryDocument(rowData)"
                            tabindex="0">
                            <i class="fa fa-file fa-lg" pTooltip="Preview"></i
                          ></a>
                        }
                      </td>
                      <td>{{ rowData.uploadDate | date: 'MM/dd/yyyy' }}</td>
                      <td>{{ checkPoeDocumentType(rowData.poeDocName) }}</td>
                      <td>{{ rowData.status }}</td>
                      <td>
                        @if (rowData.reasons) {
                          <span>{{ getReasons(rowData.reasons) }}</span>
                        }
                      </td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
              <div class="edittablebdr">
                <div class="ui-g">
                  <div class="ui-g-12 ui-md-12 ui-lg-12">
                    <div class="hdbl">Additional Documents</div>
                  </div>
                </div>

                <p-table [value]="additionalDocHyperLinks">
                  <ng-template #header let-columns>
                    <tr>
                      <th style="width: 25%">Document Name</th>
                      <th style="width: 25%">Preview</th>
                      <th style="width: 25%">Upload Date</th>
                      <th style="width: 25%">Type</th>
                    </tr>
                  </ng-template>
                  <ng-template #body let-rowData>
                    <tr>
                      <td>
                        <a
                          class="doc-name"
                          target="_blank"
                          href="{{ rowData.addnlDocFilePath }}"
                          >{{ rowData.addnlDocName }}</a
                        >
                      </td>
                      <td>
                        <a
                          class="ml-2"
                          (click)="previewAdditionalDocument(rowData)"
                          (keyup.enter)="previewAdditionalDocument(rowData)"
                          tabindex="0">
                          <i class="fa fa-file fa-lg" pTooltip="Preview"></i
                        ></a>
                      </td>
                      <td>{{ rowData.uploadDate }}</td>
                      <td>{{ checkDocumentType(rowData.documentTypeId) }}</td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            </div>
          </form>
        </p-tabpanel>
        <p-tabpanel value="10">
          <app-poe-submission-special-investments
            [engagementId]="this.engementId"
            [programType]="this.programTypeId"
            (closePreviewModal)="refreshNotes()">
          </app-poe-submission-special-investments>
        </p-tabpanel>
      </p-tabpanels>
    </p-tabs>
  </div>
}

<p-dialog
  [(visible)]="loadcustomAck"
  [contentStyle]="{
    'max-height': '550px',
    'overflow-y': 'auto',
    width: '700px',
    'z-index': '10027px'
  }"
  [closable]="false"
  [draggable]="false"
  showEffect="fade"
  [modal]="false">
  <ng-template #header>
    <div class="ui-g-11">
      {{ fileUploadHeader }}
    </div>
    <div
      class="ui-g-1 closesidebar diaclnav"
      (click)="cancelCustomAckNav()"
      (keydown.enter)="cancelCustomAckNav()"
      tabindex="0">
      <i class="mdl2-cancel cpointer" style="float: right; color: #212121"></i>
    </div>
  </ng-template>

  <div class="tolFile">
    <p>
      File size must be less than 10 MB.
      @if (showUploadedFiles) {
        <span>Acceptable file types: image or pdf</span>
      }
    </p>
  </div>
  <div class="tolFile">
    <p><b>Note: </b>Drag and Drop/Browse files will be Uploaded to Server.</p>
  </div>
  @for (message of umsgs; track message) {
    <p-message [life]="3000" [text]="message.detail"></p-message>
  }
  <div
    class="uploadfilecontainer"
    appDragDrop
    (onFileDropped)="uploadFile($event)">
    <div><i class="fa fa-cloud-upload fa-lg"></i></div>
    Drag and drop files here or
    <a
      (click)="fileInputUpload.click()"
      (keydown.enter)="fileInputUpload.click()"
      tabindex="0"
      >Browse</a
    >
    <input
      hidden
      type="file"
      #fileInputUpload
      (change)="uploadFile($event.target)" />
  </div>
  @if (filesUpload) {
    <div class="tolFile">
      <p>
        Total Number of File in Uploading:
        {{ filesUpload.length }}
      </p>
    </div>
  }
  <div class="files-list listtable">
    <table>
      <tr *ngFor="let file of filesUpload; let i = index">
        <td>{{ file.fileName }}</td>
        <td class="tdwidth">
          @if (fileUploadSpinners[i] !== true) {
            <i class="fa fa-check-circle"></i>
          }
          @if (fileUploadSpinners[i] === true) {
            <i class="fa fa-spinner fa-spin"></i>
          }
        </td>
        <td class="tdwidth">
          @if (fileUploadSpinners[i] !== true) {
            <span>{{ formatBytes(file?.size, 0) }}</span>
          }
          @if (fileUploadSpinners[i] === true) {
            <i class="fa fa-spinner fa-spin"></i>
          }
        </td>
      </tr>
    </table>
  </div>
  @if (showUploadedFiles) {
    <div class="tolFile">
      <p>Files in List</p>
    </div>
    <div class="files-list listtable">
      <table>
        <thead>
          <tr>
            <th width="7">File Name</th>
            <th class="tdwidth">Preview</th>
            <th class="tdwidth">Download</th>
            <th class="tdwidth">Delete</th>
          </tr>
        </thead>
        <tr *ngFor="let file of customerAck; let i = index">
          <td>
            @if (downloadSpin[i] === true) {
              <img
                src="../../../assets/images/download.gif"
                width="7"
                alt="Downloading..." />
            }
            {{ file.fileName }}
          </td>
          <td class="tdwidth">
            @if (canShowPreviewButton(file.fileName || '')) {
              <a
                (click)="previewFile(i)"
                tabindex="0"
                (keydown.enter)="previewFile(i)">
                <i
                  class="fa fa-file fa-lg"
                  aria-hidden="true"
                  pTooltip="Preview"
                  tooltipPosition="bottom"></i>
              </a>
            }
          </td>
          <td class="tdwidth">
            <a
              (click)="downloadFile(i)"
              tabindex="0"
              (keydown.enter)="downloadFile(i)">
              <i
                class="fa fa-download fa-lg"
                aria-hidden="true"
                pTooltip="Download"
                tooltipPosition="bottom"></i>
            </a>
          </td>
          <td class="tdwidth">
            <a
              (click)="deleteAttachment(i)"
              tabindex="0"
              (keydown.enter)="deleteAttachment(i)">
              <i
                class="fa fa-remove fa-lg"
                aria-hidden="true"
                pTooltip="Delete"
                tooltipPosition="bottom"></i>
            </a>
          </td>
        </tr>
      </table>
    </div>
  }
  <br />
  <div style="text-align: right">
    <button
      type="submit"
      pButton
      (click)="submitCustomerAckFile()"
      class="flat btnmr">
      Submit
    </button>
    <button
      type="button"
      pButton
      (click)="cancelCustomAckNav()"
      class="ui-button-secondary flat">
      Cancel
    </button>
  </div>
</p-dialog>

@if (canShowPreviewModel) {
  <app-engagement-preview
    (OnPoeDocumentReview)="reviewPoeDocument($event)"
    (OnDocumentTypeChange)="refreshAdditionalDocument($event)"
    (OnCustomerAckReview)="reviewCustomerAck($event)"
    (OnInvoiceReview)="reviewPoeInvoice($event)"
    [engagementPreviewInput]="engagementPreviewInput"
    (closePreviewModal)="closePreview()"></app-engagement-preview>
}
